module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    attrs: {
      "id": "navse",
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns navbar-full is-gapless is-mobile"
  }, [_c('div', {
    staticClass: "column is-7 navbar-brand",
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    style: ({
      maxHeight: 'auto'
    }),
    attrs: {
      "src": require("../assets/logo.svg"),
      "width": "150"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column has-text-right"
  }), _vm._v(" "), (false) ? _c('div', {
    staticClass: "column column-link is-narrow is-hidden-touch",
    class: {
      'is-active': _vm.$route.name === 'shop'
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showNav),
      expression: "!showNav"
    }],
    attrs: {
      "href": "http://shop.lasting-impressions.com.my"
    }
  }, [_vm._v("Shop")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column column-link is-narrow is-hidden-touch",
    class: {
      'is-active': _vm.$route.name === 'landing'
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showNav),
      expression: "!showNav"
    }],
    attrs: {
      "href": "/?anchor=gallery-container"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('landing', 'gallery-container')
      }
    }
  }, [_vm._v("\n          Gallery\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column column-link is-narrow is-hidden-touch",
    class: {
      'is-active': _vm.$route.name === 'about'
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showNav),
      expression: "!showNav"
    }],
    attrs: {
      "href": "/about",
      "to": "about"
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('div', {
    staticClass: "column column-link is-narrow is-hidden-touch",
    class: {
      'is-active': _vm.$route.name === 'locate'
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showNav),
      expression: "!showNav"
    }],
    attrs: {
      "href": "/locate",
      "to": "locate"
    }
  }, [_vm._v("Locate")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow navbar-menu",
    attrs: {
      "data-aos": "zoom-in",
      "data-aos-once": "true"
    },
    on: {
      "click": function($event) {
        _vm.onToggle()
      }
    }
  }, [_c('div', {
    staticClass: "control-menu",
    class: {
      active: _vm.showNav
    }
  }, [_c('span')])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-narrow is-hidden-touch has-text-centered"
  }, [_c('a', {
    staticClass: "top-icon instagram",
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "8px"
    },
    attrs: {
      "href": "https://www.instagram.com/lastingimpressionskl/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-1_5x fa-instagram",
    staticStyle: {
      "vertical-align": "middle",
      "margin": "auto"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-narrow is-hidden-touch has-text-centered"
  }, [_c('a', {
    staticClass: "top-icon facebook",
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "8px"
    },
    attrs: {
      "href": "https://www.facebook.com/lastingimpressionskl/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-1_5x fa-facebook",
    staticStyle: {
      "vertical-align": "middle",
      "margin": "auto"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7e14cac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBarFull.vue
// module id = 748
// module chunks = 1